module.exports = __webpack_public_path__ + "44436235c811259e9729c6f3b82ec53d.fbx";